import settings from "./settings";

const NotificationItem = ({ title, message, onClick }) => {
  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const hoverBackgroundColor = settings.hoverBackgroundColor.value;
  const borderColor = settings.borderColor.value;
  const hoverBorderColor = settings.hoverBorderColor.value;
  const titleColor = settings.titleColor.value;
  const messageColor = settings.messageColor.value;
  const shadowColor = settings.shadowColor.value;
  const hoverShadowColor = settings.hoverShadowColor.value;
  const paddingX = settings.paddingX.value + "px";
  const paddingY = settings.paddingY.value + "px";
  const marginX = settings.marginX.value + "px";
  const marginBottom = settings.marginBottom.value + "px";
  const borderRadius = settings.borderRadius.value + "px";
  const borderWidth = settings.borderWidth.value + "px";
  const titleFontSize = settings.titleFontSize.value + "px";
  const messageFontSize = settings.messageFontSize.value + "px";
  const titleFontWeight = settings.titleFontWeight.value;
  const messageFontWeight = settings.messageFontWeight.value;
  const titleMarginBottom = settings.titleMarginBottom.value + "px";
  const messageHeight = settings.messageHeight.value + "px";
  const messageLineHeight = settings.messageLineHeight.value;
  const titleLineHeight = settings.titleLineHeight.value;
  const shadowBlur = settings.shadowBlur.value + "px";
  const hoverShadowBlur = settings.hoverShadowBlur.value + "px";
  const animationDuration = settings.animationDuration.value + "ms";
  const showBorder = settings.showBorder.value;
  const showShadow = settings.showShadow.value;
  const hoverEffects = settings.hoverEffects.value;
  const clickable = settings.clickable.value;
  const textEllipsis = settings.textEllipsis.value;
  const maxLines = settings.maxLines.value;
  const textAlign = settings.textAlign.value;

  const getBoxShadow = (isHover = false) => {
    if (!showShadow) return "none";
    const color = isHover ? hoverShadowColor : shadowColor;
    const blur = isHover ? hoverShadowBlur : shadowBlur;
    return `0 1px ${blur} ${color}`;
  };

  const getTextOverflowStyle = () => {
    if (!textEllipsis) return {};
    return {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitLineClamp: maxLines,
      WebkitBoxOrient: "vertical",
      textOverflow: "ellipsis",
    };
  };

  return (
    <div
      style={{
        border: showBorder ? `${borderWidth} solid ${borderColor}` : "none",
        borderRadius: borderRadius,
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingTop: paddingY,
        paddingBottom: paddingY,
        marginBottom: marginBottom,
        marginLeft: marginX,
        marginRight: marginX,
        cursor: clickable ? "pointer" : "default",
        backgroundColor: backgroundColor,
        boxShadow: getBoxShadow(),
        transition: hoverEffects ? `all ${animationDuration} ease` : "none",
        textAlign: textAlign,
      }}
      onClick={clickable ? onClick : undefined}
      onMouseEnter={(e) => {
        if (hoverEffects) {
          e.target.style.backgroundColor = hoverBackgroundColor;
          e.target.style.borderColor = showBorder
            ? hoverBorderColor
            : "transparent";
          e.target.style.boxShadow = getBoxShadow(true);
        }
      }}
      onMouseLeave={(e) => {
        if (hoverEffects) {
          e.target.style.backgroundColor = backgroundColor;
          e.target.style.borderColor = showBorder ? borderColor : "transparent";
          e.target.style.boxShadow = getBoxShadow(false);
        }
      }}
    >
      <div
        style={{
          fontWeight: titleFontWeight,
          fontSize: titleFontSize,
          color: titleColor,
          marginBottom: titleMarginBottom,
          lineHeight: titleLineHeight,
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontWeight: messageFontWeight,
          fontSize: messageFontSize,
          color: messageColor,
          height: messageHeight,
          lineHeight: messageLineHeight,
          ...getTextOverflowStyle(),
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default NotificationItem;
